// extracted by mini-css-extract-plugin
export default {"container":"BenefactorSubscriptions_container__ACDm2","content":"BenefactorSubscriptions_content__OkR4B","sectionsContainer":"BenefactorSubscriptions_sectionsContainer__isZpb"};